<template>
  <!--经营异常-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :scroll="scroll"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      scroll: { x: 1300 },
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '列入经营异常原因',
          dataIndex: 'shiftInReason',
          key: 'shiftInReason',
        },
        {
          title: '列入日期',
          dataIndex: 'shiftInDate',
          key: 'shiftInDate',
        },
        {
          title: '作出决定机关(列入)',
          dataIndex: 'shiftInOffice',
          key: 'shiftInOffice',
        },
        {
          title: '移出经营异常原因',
          dataIndex: 'shiftOutReason',
          key: 'shiftOutReason',
        },
        {
          title: '移出日期',
          dataIndex: 'shiftOutDate',
          key: 'shiftOutDate',
        },
        {
          title: '作出决定机关(移出)',
          dataIndex: 'shiftOutOffice',
          key: 'shiftOutOffice',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
